<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon v-if="$store.state.router_from.name === 'payment' || $router.currentRoute.query.redirect === 'payment' || $store.state.router_from.name === 'checkout' || $router.currentRoute.query.redirect === 'checkout'" class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('login') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form class="py-12 px-2">
            <ValidationProvider v-slot="{ errors, valid }" name="emailorphone" rules="required">
              <v-text-field v-model="form.username" outlined dense type="text" :label="$t('mail_phone')" color="primary" :error-messages="errors" />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors, valid }" name="password" rules="required|min:8">
              <v-text-field v-model="form.password" outlined dense :type="visibility ? 'text' : 'password'" :label="$t('password')" color="primary" :error-messages="errors" :append-icon="visibility ? 'mdi-eye' : 'mdi-eye-off'" autocomplete="on" @click:append="visibility = !visibility" />
            </ValidationProvider>
            <v-btn color="primary" x-large block class="text-none" @click="login()">
              {{ $t('login') }}
            </v-btn>
            <template v-if="!$isEmpty($store.state.selected_store) && $store.state.selected_store.url_id !== 'farazmart'">
              <v-btn v-if="$store.state.router_from.name === 'payment' || $router.currentRoute.query.redirect === 'payment' || $store.state.router_from.name === 'checkout' || $router.currentRoute.query.redirect === 'checkout'" color="primary" outlined x-large block class="text-none mt-4" @click="loginAsGuest()">
                {{ $t('login_as_guest_2') }}
              </v-btn>
              <v-btn v-else color="primary" outlined x-large block class="text-none mt-4" @click="loginAsGuest()">
                {{ $t('login_as_guest') }}
              </v-btn>
            </template>
            <div class="mt-5 text-center">
              <router-link :to="{ name: 'forget_password' }" class="grey--text text-non-direction">
                {{ $t('forgot_password') }}
              </router-link>
            </div>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
    <v-row v-if="$store.state.router_from.name === 'payment' || $router.currentRoute.query.redirect === 'payment' || $store.state.router_from.name === 'checkout' || $router.currentRoute.query.redirect === 'checkout'">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="text-center">
        <span class="grey--text">{{ $t('dont_have_an_account_yet') }} </span>
        <a class="primary--text font-weight-bold" @click="register()">{{ $t('register_here') }}</a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  login as loginCustomer
} from '@/api/auth'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      visibility: false,
      password: 'Password',
      form: {
        username: '',
        password: '',
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        grant_type: 'password'
      },
      form_verification: {}
    }
  },
  methods: {
    register() {
      this.$router.push({ name: 'register', query: { redirect: this.$route.query.redirect }}).catch(() => {})
    },
    async login() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          const { data } = await loginCustomer(this.form)
          this.$store.state.loading_axios = false
          this.$store.dispatch('save_token', data)
          const query = this.$route.query.redirect
          if (query) {
            if (query === 'order') {
              this.$router.push({ name: query, params: { id: this.$route.query.id }}).catch(() => {})
            } else if (query === 'reservation_place' && this.$route.query.date) {
              this.$router.push({ name: query, query: { date: this.$route.query.date }}).catch(() => {})
            } else {
              this.$router.push({ name: query }).catch(() => {})
            }
          } else {
            const astra_outlet = this.$store.state.store_astra
            const tmii_outlet = this.$store.state.store_tmii
            const url_id = this.$store.state.url_domain

            if (tmii_outlet.indexOf(url_id) !== -1) {
              window.location.href = 'https://order.kulinertmii.id'
            } else if (astra_outlet.indexOf(url_id) !== -1) {
              window.location.href = 'https://zestloungemenaraastra.myolsera.com'
            } else {
              this.$router.push({ name: 'home' }).catch(() => {})
            }
          }
        } catch (e) {
          if (e.statusCode === 403) {
            this.$router.push({ name: 'select_otp_login', query: { redirect: this.$route.query.redirect }}).catch(() => {})
            const data_verify = {
              key_pre_register: '',
              value: e.data
            }
            this.$store.dispatch('data_verification', data_verify)
            // this.$store.dispatch('save_type_verification', 'phone')
            // try {
            //   this.form_verification = {
            //     phone: e.data.phone
            //   }
            //   await sendOtpCustomer(this.form_verification)
            //   this.$store.state.loading_axios = false
            // } catch (e) {
            //   this.$store.state.show_error = true
            //   this.$store.state.error_message = e.string
            //   this.$store.state.error_type = e.statusCode
            // }
            // this.$router.push({ name: 'select_verification', query: { redirect: this.$route.query.redirect }}).catch(() => {})
          } else {
            if (typeof e.error_tagging !== 'undefined' && e.error_tagging === 'NEED_RESET_PASSWORD') {
              this.$router.push({ name: 'set_new_password', query: { redirect: this.$route.query.redirect }}).catch(() => {})
            } else {
              this.$store.state.show_error = true
              this.$store.state.error_message = e.string
              this.$store.state.error_type = e.statusCode
            }
          }
        }
      }
    },
    loginAsGuest() {
      if (this.$route.query.id) {
        this.$router.push({ name: 'login_guest', query: { redirect: this.$route.query.redirect, id: this.$route.query.id }}).catch(() => {})
      } else if (this.$route.query.redirect === 'reservation_place' && this.$route.query.date) {
        this.$router.push({ name: 'login_guest', query: { redirect: this.$route.query.redirect, date: this.$route.query.date }}).catch(() => {})
      } else {
        this.$router.push({ name: 'login_guest', query: { redirect: this.$route.query.redirect }}).catch(() => {})
      }
    },
    goBack() {
      this.$router.push({ name: 'checkout' }).catch(() => {})
    }
  }
}
</script>
